module.exports = __webpack_public_path__ + "img/login_logo.64e2dabe.png";